<template>
  <div class="uc-avatar-div">
    <el-avatar :size="getSize" :src="getSrc" :shape="shap" :src-set="srcSet" :alt="alt" :fit="fit" @error="errorHandler">
      <img :src="getDefaultImage"/>
    </el-avatar>
    <svg :class="'icon ' + getSexClass" aria-hidden="true" v-if="sex == 1">
      <use xlink:href="#icon-female"></use>
    </svg>
    <svg :class="'icon ' + getSexClass" aria-hidden="true" v-if="sex == 0">
      <use xlink:href="#icon-male"></use>
    </svg>
  </div>
</template>

<script>
import femaleImage from '../../styles/avatar/images/female-default.svg'
import maleImage from '../../styles/avatar/images/male-default.svg'
export default {
  name: 'AvatarIndex',
  components: {
  },
  data() {
    return {
    }
  },
  props: {
    size: {
      type: String,
      default: ''
    },
    src: {
      type: String,
      default: ''
    },
    shap: {
      type: String,
      default: 'circle'
    },
    srcSet: {
      type: String,
      default: ''
    },
    alt: {
      type: String,
      default: ''
    },
    fit: {
      type: String,
      default: ''
    },
    sex: {
      type: String,
      default: '-1'
    }
  },
  computed: {
    getSrc(){
      if(this.src){
        return this.src;
      }
      if(this.sex == 1){
        return femaleImage;
      }
      return maleImage;
    },
    getSize(){
      if(this.size){
        return this.size;
      }
      return 80;
    },
    getSexClass(){
      if(this.size && this.size == 'medium'){
        return 'uc-avatar-sex-medium';
      }
      if(this.size && this.size == 'small'){
        return 'uc-avatar-sex-small';
      }
      return 'uc-avatar-sex';
    },
    getDefaultImage(){
      if(this.sex == 1){
        return femaleImage;
      }
      return maleImage;
    },
  },
  methods: {
    errorHandler() {
      return true
    }
  },
};
</script>
